import {
  URL_XHR_DEAL_CHANGE_STATE_ARCHIVED,
  URL_XHR_DEAL_CHANGE_STATE_RESTORED,
} from '@tools/routes/routes';
import translation from '@elements/translation';
import eventBus from '@tools/event-bus';
import messagingMixins from '../../mixins';
import baseXhrRequestMixin from './base-xhr-request-mixin';

export default {
  mixins: [ messagingMixins, translation, baseXhrRequestMixin ],
  methods: {
    async toggleArchiveDeal(
      dealId,
      action = 'archive',
      archiveFilterActive = false,
    ) {
      const urlDealArchive = (
        action === 'archive'
          ? URL_XHR_DEAL_CHANGE_STATE_ARCHIVED
          : URL_XHR_DEAL_CHANGE_STATE_RESTORED
      ).replace('{id}', dealId);

      const response = await this.get(
        urlDealArchive,
        archiveFilterActive ? { archived: true } : {},
      );
      eventBus.dispatchEvent(new Event('archive-restore-deal-callback'));
      this.commonMenuActionsPostXhrRequest(response, dealId, action);
      if (response && response.data) {
        const { conversation } = JSON.parse(response.data);
        if (Number(this.$route.params?.id) === dealId) {
          this.updateMessagingView(conversation);
        }
        this.removeDealFromInboxList(dealId);
        return JSON.parse(response.data);
      }
      return null;
    },
  },
};
